import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../App';
import { Box, CircularProgress, Typography, Container, Button } from '@mui/material';
import { FaSignInAlt } from 'react-icons/fa';

const GruempelRedirect = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/gruemp/public/latest`)
            .then(res => {
                const turnier = res.data;
                if (turnier && turnier.date) {
                    const year = new Date(turnier.date).getFullYear();
                    navigate(`/gt/${year}`, { replace: true });
                } else {
                    setError("Kein aktives Turnier gefunden.");
                    setLoading(false);
                }
            })
            .catch(err => {
                console.error("Error fetching latest published tournament", err);
                setError("Aktuell ist kein Grümpelturnier veröffentlicht.");
                setLoading(false);
            });
    }, [navigate]);

    if (loading) {
        return (
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="80vh" gap={2}>
                <CircularProgress color="primary" size={50} />
                <Typography variant="h6" color="textSecondary">
                    TC Opfingen Grümpelturnier wird geladen...
                </Typography>
            </Box>
        );
    }

    return (
        <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
            <Box sx={{ p: 4, borderRadius: 3, bgcolor: 'rgba(255,255,255,0.9)', boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
                <Typography variant="h5" color="error" gutterBottom sx={{ fontWeight: 600 }}>
                    Turnier-Info nicht verfügbar
                </Typography>
                <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
                    {error}
                </Typography>
                <Button variant="contained" color="primary" component={Link} to="/login" startIcon={<FaSignInAlt />}>
                    Zum Login
                </Button>
            </Box>
        </Container>
    );
};

export default GruempelRedirect;
